import { useCallback } from 'react'
import userHasPrivs from 'Helper/Auth/userHasPrivs'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import { columnNameAsString } from '../../XtractTableUtils.jsx'


const useCSV = ({table, downloadFileName, propsManual, matchesCount, pagination, dataLength}) => {
  const downloadCsvPriv = userHasPrivs('download_csv')

  const hasPII = useCallback(() => {
    // are any of the visible columns PII?
    return table?.getAllLeafColumns()
      .filter(column => column.getIsVisible())
      .some(column => column.columnDef.isPII)
  }, [table?.getAllLeafColumns])

  const downloadCSV = useCallback((start, count, includePII) => {
    const currentRecords = table?.getRowModel().rows.slice(start, start + count)

    const dataToDownload = currentRecords.map(record => {
      const outputRecord = {}

      record.getVisibleCells()
        // only include selected columns and if a column is PII, include it only if we're supposed to
        .filter(cell =>
          cell.column.columnDef.downloadText !== false &&
          cell.column.columnDef.showable !== false &&
          (includePII || !cell.column.columnDef.isPII)
        )
        .forEach(cell => {
          const columnName = columnNameAsString(cell.column.columnDef)
          outputRecord[columnName] =
            typeof cell.column.columnDef.downloadText === 'function'
              ? cell.column.columnDef.downloadText(record.original)
              : cell.getValue()
        })

      return outputRecord
    })

    const CSV = Papa.unparse(dataToDownload)
    saveAs(
      new Blob([CSV], {
        type: 'text/csv;charset=utf-8'
      }),
      downloadFileName + '.csv'
    )
  }, [downloadFileName, table?.getRowModel])

  const confirmCSVDownload = useCallback((confirmCallback) => {
    const { pageIndex, pageSize } = pagination
    const pages = table?.getPageCount()
    let rowCount = table?.getRowModel().rows.length
    let start = 0
    let totalRows = dataLength
    if (propsManual) {
      totalRows = matchesCount
    } else {
      start = pageIndex * pageSize
      rowCount = Math.min(
        pageSize,
        totalRows - pageIndex * pageSize
      )
    }
    const tableHasPII = hasPII()
    if (pages > 1 || tableHasPII) {
      confirmCallback(rowCount, totalRows, pageSize, tableHasPII, (includePII) => downloadCSV(start, rowCount, includePII))
    } else {
      downloadCSV(0, dataLength, true)
    }
  }, [
    table?.getPageCount,
    pagination.pageIndex,
    pagination.pageSize,
    table?.getRowModel,
    propsManual,
    matchesCount,
    downloadCSV,
    dataLength
  ])

  return {
    downloadCsvPriv,
    confirmCSVDownload,
    hasPII
  }
}

export default useCSV